import * as React from 'react'

function SvgCampaigns(props) {
  return (
    <svg width={20} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        opacity={0.5}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 14.5A1.5 1.5 0 001.5 16h17a1.5 1.5 0 001.5-1.5v-10A1.5 1.5 0 0018.5 3H9L6.44.44A1.5 1.5 0 005.378 0H1.5A1.5 1.5 0 000 1.5v13z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgCampaigns
